document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-menu-toggle]'), nav=document.querySelector('[data-mobile-nav]');
  if(toggle&&nav){
    const closeMenu=()=>{toggle.setAttribute('aria-expanded','false');nav.classList.remove('is-open');document.body.classList.remove('menu-open')};
    toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open);document.body.classList.toggle('menu-open',!open)});
    nav.querySelector('[data-menu-close]')?.addEventListener('click',closeMenu);
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&nav.classList.contains('is-open'))closeMenu()});
  }
  const searchDialog=document.querySelector('[data-search-dialog]');
  document.querySelectorAll('[data-search-open]').forEach(button=>button.addEventListener('click',()=>{
    if(!searchDialog) return;
    if(typeof searchDialog.showModal==='function') searchDialog.showModal(); else searchDialog.setAttribute('open','');
    document.body.classList.add('search-open');
    requestAnimationFrame(()=>searchDialog.querySelector('[data-search-input]')?.focus());
  }));
  const closeSearch=()=>{if(searchDialog?.open) searchDialog.close();document.body.classList.remove('search-open')};
  searchDialog?.querySelector('[data-search-close]')?.addEventListener('click',closeSearch);
  searchDialog?.addEventListener('close',()=>document.body.classList.remove('search-open'));
  searchDialog?.addEventListener('click',event=>{if(event.target===searchDialog) closeSearch()});

  const desktopMenus=[...document.querySelectorAll('.main-nav--premium .nav-dropdown > details')];
  desktopMenus.forEach(panel=>panel.addEventListener('toggle',()=>{
    if(!panel.open) return;
    desktopMenus.forEach(other=>{if(other!==panel) other.open=false});
  }));
  document.addEventListener('click',event=>{
    if(!event.target.closest('.main-nav--premium')) desktopMenus.forEach(panel=>panel.open=false);
  });

  if(nav) nav.querySelectorAll(':scope > details').forEach(panel=>panel.addEventListener('toggle',()=>{
    if(!panel.open) return;
    nav.querySelectorAll(':scope > details').forEach(other=>{if(other!==panel) other.open=false});
  }));
  document.querySelectorAll('[data-quantity-minus],[data-quantity-plus]').forEach(button=>button.addEventListener('click',()=>{
    const input=button.parentElement.querySelector('input[type="number"]');
    if(!input) return;
    const value=Math.max(Number(input.min||1),Number(input.value||1)+(button.hasAttribute('data-quantity-plus')?1:-1));
    input.value=value;
    input.dispatchEvent(new Event('change',{bubbles:true}));
  }));
  document.querySelectorAll('[data-scroll-row]').forEach(row=>{const prev=document.querySelector(`[data-scroll-prev="${row.id}"]`),next=document.querySelector(`[data-scroll-next="${row.id}"]`);prev?.addEventListener('click',()=>row.scrollBy({left:-row.clientWidth*.7,behavior:'smooth'}));next?.addEventListener('click',()=>row.scrollBy({left:row.clientWidth*.7,behavior:'smooth'}))});

  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    const images=[...gallery.querySelectorAll('[data-gallery-image]')];
    const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
    const count=gallery.querySelector('[data-gallery-count]');
    thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{
      const index=Number(thumb.dataset.galleryThumb);
      images.forEach((item,itemIndex)=>{item.hidden=itemIndex!==index;item.classList.toggle('is-active',itemIndex===index)});
      thumbs.forEach((item,itemIndex)=>{item.classList.toggle('is-active',itemIndex===index);item.setAttribute('aria-pressed',String(itemIndex===index))});
      if(count) count.textContent=(index+1)+' / '+images.length;
    }));
  });

  document.querySelectorAll('.premium-product__form').forEach(form=>{
    const variantData=form.querySelector('[data-product-variants]');
    const idInput=form.querySelector('[data-variant-id]');
    const addButton=form.querySelector('[data-add-to-cart]');
    const addLabel=form.querySelector('[data-add-label]');
    const priceBox=form.closest('.premium-product__details')?.querySelector('[data-product-price]');
    if(!variantData||!idInput||!addButton) return;
    let variants=[];
    try{variants=JSON.parse(variantData.textContent)}catch(error){return}
    const updateVariant=()=>{
      const chosen=[...form.querySelectorAll('[data-product-option]:checked')]
        .sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition))
        .map(input=>input.value);
      if(!chosen.length) return;
      const variant=variants.find(item=>item.options.every((option,index)=>option===chosen[index]));
      if(!variant){
        addButton.disabled=true;
        if(addLabel) addLabel.textContent='Unavailable';
        return;
      }
      idInput.value=variant.id;
      addButton.disabled=!variant.available;
      if(addLabel) addLabel.textContent=variant.available?'Add to cart':'Sold out';
      if(priceBox){
        priceBox.textContent='';
        const price=document.createElement('span');
        price.textContent=variant.price;
        priceBox.append(price);
        if(variant.compare){
          const compare=document.createElement('s');
          compare.textContent=variant.compare;
          priceBox.append(compare);
        }
      }
      const url=new URL(window.location.href);
      url.searchParams.set('variant',variant.id);
      window.history.replaceState({},'',url);
    };
    form.querySelectorAll('[data-product-option]').forEach(input=>input.addEventListener('change',updateVariant));
  });

  const sizeGuide=document.querySelector('[data-size-guide-modal]');
  document.querySelectorAll('[data-size-guide-open]').forEach(button=>button.addEventListener('click',()=>sizeGuide?.showModal()));
  sizeGuide?.querySelector('[data-size-guide-close]')?.addEventListener('click',()=>sizeGuide.close());
  sizeGuide?.addEventListener('click',event=>{if(event.target===sizeGuide) sizeGuide.close()});

  const deliveryModal=document.querySelector('[data-delivery-modal]');
  document.querySelectorAll('[data-delivery-open]').forEach(button=>button.addEventListener('click',()=>deliveryModal?.showModal()));
  deliveryModal?.querySelector('[data-delivery-close]')?.addEventListener('click',()=>deliveryModal.close());
  deliveryModal?.addEventListener('click',event=>{if(event.target===deliveryModal) deliveryModal.close()});
});
